import { IExtendedBenefitsData } from '@/interfaces/cars.interfaces';

/**
 * Возвращает номер сноски для выгоды, если она есть.
 * @param benefits список всех выгод (подразумевается, что отсортированы в порядке отображения)
 * @param benefit выгода, для которой нужно получить номер сноски
 * @returns номер сноски.
 */
export function getFootNoteNumber(
  benefits: Array<IExtendedBenefitsData>,
  benefit: IExtendedBenefitsData,
) {
  let footNoteNumber = 0;

  if (!benefit.description) {
    return null;
  }

  for (const b of benefits) {
    if (b.description) {
      footNoteNumber += 1;
    }

    if (b === benefit) {
      return footNoteNumber;
    }
  }

  return null;
}

export default getFootNoteNumber;
